// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Filters_contentContainer__E96x\\+ {
  width: auto;
  padding-top: calc(50px + 32px);
}

.Filters_form__qD6gM {
  min-width: 318px;
}

.Filters_tableBlock__to2m\\+ {
  overflow-y: auto;
  margin-right: 1px;
  height: calc(100vh - 250px);
  padding-right: 0.5rem;
}
.Filters_tableBlock__to2m\\+::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background-color: transparent;
}
.Filters_tableBlock__to2m\\+::-webkit-scrollbar-track {
  border-radius: 0;
}
.Filters_tableBlock__to2m\\+::-webkit-scrollbar-thumb {
  background-color: #bec2c5;
  border-radius: 0;
}

.Filters_table__lPfZ8 {
  word-break: break-word;
}
.Filters_table__lPfZ8 thead {
  position: sticky;
  top: 0;
}
.Filters_table__lPfZ8 th:nth-child(1) {
  width: 16%;
  min-width: 135px;
}
.Filters_table__lPfZ8 th:nth-child(2) {
  width: 42%;
}
.Filters_table__lPfZ8 th:nth-child(3) {
  width: 42%;
}
.Filters_table__lPfZ8 td {
  vertical-align: middle;
  padding: 0 8px;
  height: 64px;
}
.Filters_table__lPfZ8 a {
  text-decoration: none;
}
.Filters_table__lPfZ8 a:hover {
  text-decoration: underline;
}

.Filters_link__vZ3jd {
  background-color: transparent;
  border: none;
  color: #00857C;
}
.Filters_link__vZ3jd:active, .Filters_link__vZ3jd:hover {
  color: #006760;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/pages/Filters/Filters.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,8BAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;ECXI,gBAAA;EACA,iBAAA;EDYF,2BAAA;EACA,qBAAA;AADF;ACVI;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ADYR;ACTI;EACI,gBAAA;ADWR;ACRI;EACI,yBAAA;EACA,gBAAA;ADUR;;AARA;EACE,sBAAA;AAWF;AATE;EACE,gBAAA;EACA,MAAA;AAWJ;AAPI;EACE,UAAA;EACA,gBAAA;AASN;AANI;EACE,UAAA;AAQN;AALI;EACE,UAAA;AAON;AAHE;EACE,sBAAA;EACA,cAAA;EACA,YAAA;AAKJ;AAFE;EACE,qBAAA;AAIJ;AAFI;EACE,0BAAA;AAIN;;AACA;EACE,6BAAA;EACA,YAAA;EACA,cAAA;AAEF;AAAE;EAEE,cAAA;EACA,eAAA;AACJ","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n@import '../../styles/mixins.scss';\n\n.contentContainer {\n  width: auto;\n  padding-top: calc(#{$navbarHeight} + 32px);\n}\n\n.form {\n  min-width: 318px;\n}\n\n.tableBlock {\n  @include custom-scrollbar();\n  height: calc(100vh - 250px);\n  padding-right: .5rem;\n}\n\n.table {\n  word-break: break-word;\n\n  thead {\n    position: sticky;\n    top: 0;\n  }\n\n  th {\n    &:nth-child(1) {\n      width: 16%;\n      min-width: 135px;\n    }\n\n    &:nth-child(2) {\n      width: 42%;\n    }\n\n    &:nth-child(3) {\n      width: 42%;\n    }\n  }\n\n  td {\n    vertical-align: middle;\n    padding: 0 8px;\n    height: 64px;\n  }\n\n  a {\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.link {\n  background-color: transparent;\n  border: none;\n  color: #00857C;\n\n  &:active,\n  &:hover {\n    color: #006760;\n    cursor: pointer;\n  }\n}","@mixin custom-scrollbar {\n    overflow-y: auto;\n    margin-right: 1px;\n\n    &::-webkit-scrollbar {\n        width: 0.5rem;\n        height: 0.5rem;\n        background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 0;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #bec2c5;\n        border-radius: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `Filters_contentContainer__E96x+`,
	"form": `Filters_form__qD6gM`,
	"tableBlock": `Filters_tableBlock__to2m+`,
	"table": `Filters_table__lPfZ8`,
	"link": `Filters_link__vZ3jd`
};
export default ___CSS_LOADER_EXPORT___;
